import React from 'react'
import { useState } from 'react';
// import { Link } from 'react-router-dom';
// import Peshbiniakan from '../data/peshbibiakan.json';
import Games from '../data/games.json';
// import Layout from '../layout/Mainlayout'
import { useSelector } from 'react-redux'
import { HiCheck } from "react-icons/hi";
import { Toast } from 'flowbite-react';


export default function Addresult(props) {

    
    const id = props.index
    

    const [toast, setToast] = useState()

    function Toastt () {
        setToast(<Toast className=''>
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500 ">
                <HiCheck className="h-5 w-5" />
            </div>
            <div className="ml-3 text-sm font-normal">
                پێشبینیەکەت سەرکەوتووبوو
            </div>
            <Toast.Toggle />
        </Toast>)
    }



    const [in1, setin1] = useState('0');
    const [in2, setin2] = useState('0');
    

    const val = (e) => {
        setin1(e.target.value)
    }

    const val2 = (e) => {
        setin2(e.target.value)
    }
    
    function hh(e) {
        
         Games[id].result =in1+"-"+in2

    }
    const user = useSelector((state) => state.user)

   
    
    const [disable, setDisable] = useState(false);

    return (
        
        <div className='bg-black fixed backdrop-blur-md bg-opacity-5 z-20 w-full bottom-0 top-0 right-0 left-0 flex flex-col p-[51px] items-center space-y-3 '>
            <div className='p-4 rounded-md'>
                <div className='flex  flex-row space-x-3 text-center border-b-[1px] md:text-xl uppercase border-penjam rounded-t-lg p-4 justify-center text-chwaram bg-yakam font-bold' >
                    
                    <img src={Games[id].logot1} alt='' /> <div className='flex items-center space-x-2'>   <p>{Games[id].team1}</p> <p className='text-c7 text-3xl'>VS </p> <p>{Games[id].team2}</p>   </div> <img src={Games[id].logot2} alt='' />
                </div>
                <form className='bg-dwam rounded-b-lg shadow-xl p-3' action='/p'>

                    <label className="block uppercase text-center p-2 drop-shadow-lg mb-2 text-2xl font-medium text-shasham ">
                        {user.userName}
                    </label>
                    
 
 

                    <label for="small-input" className="block mb-5 border-b-[1px] border-penjam text-sm font-medium text-shasham ">PESHBINI</label>

                    <div className=' flex item-center text-center justify-center space-x-3'>

                        <div>
                            <label for="small-input" className="block mb-1 text-xs font-medium text-shasham ">
                                {Games[id].team1}
                            </label>
                            <input onChange={val} type="number" min={0} id="small-input" class="block p-2 w-28 text-seyam bg-yakam rounded-lg border border-penjam sm:text-xs " required />
                        </div>

                        <div className='flex text-gray-400 items-end font-bold'>
                            <p> VS </p>
                        </div>

                        <div>
                            <label for="small-input" className="block mb-1 text-xs font-medium text-shasham ">
                                {Games[id].team2}
                            </label>
                            <input onChange={val2} type="number" min={0} id="small-input" className="block p-2 w-28 text-seyam bg-yakam rounded-lg border border-penjam sm:text-xs " required />
                        </div>

                    </div>

                    <div>

                        <button disabled={disable} onClick={() => { hh(); Toastt(); setDisable(true) }}  type="button" className="shadow-sm mt-3 shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-full overflow-hidden text-sm font-medium text-seyam rounded-lg group bg-gradient-to-br from-penjam to-shasham group-hover:from-penjam group-hover:to-shasham hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                            <span className="shadow-sm text-center shadow-penjam relative w-full px-5 py-2.5 transition-all ease-in duration-200 bg-yakam  rounded-md group-hover:bg-opacity-0">
                                پێشبینی بکە
                            </span>
                        </button>

                    </div>
                </form>
            </div>
            <div>
               {toast}
            </div>
        </div>

    )


}
